import { Moment } from 'moment'

import { IStringAnyMap } from '../../types/map'
import { FormBlueprint, FormGuidelinesType } from '../components/dynamic-form'

import { Project } from './project'
import { Formatset, FormatsetId } from './formatset'
import { Comment } from './comment'
import { Descriptive, Labeled } from '../base'
import { BlueprintMeta } from './blueprints'

export type CreativeEvent = {
  type: Labeled
  time: Moment
  user: string
}

export type CreativeMigration = {
  message: string
}

export type CreativeId = string
export type CreativeStatus = Labeled
export type CreativeFormat = Labeled
export type CreativePlacement = Descriptive
export type CreativeAction = Labeled
export type CreativeTag = string
export type CreativeState =
  | 'disabled'
  | 'selected'
  | 'over_recommended'
  | 'dragging'
  | null
export type Creative = {
  id: CreativeId
  formatsetId: FormatsetId
  name: string
  status: CreativeStatus
  type: Labeled
  possibleActions: CreativeAction[]
  tags: CreativeTag[]
  comment: Comment | null
  reopens: CreativeEvent[]
  sent: CreativeEvent[]
  outdated: CreativeEvent[]
  displayOrder: number

  project?: Project
  formatset?: Formatset

  blueprint: FormBlueprint
  blueprintMeta: BlueprintMeta
  creativeMigration: CreativeMigration
  guidelines: FormGuidelinesType
  data: IStringAnyMap
}

export function creativeActionFromDescriptive(descriptive: Descriptive) {
  return {
    name: descriptive.name,
    label: descriptive.title,
  }
}

export function creativeHasTags(
  creative: Creative,
  wantedTags: CreativeTag[],
): boolean {
  if (creative.tags == null) {
    return false
  }

  for (const tag of wantedTags) {
    if (!creative.tags.includes(tag)) {
      return false
    }
  }

  return true
}
